export default {
    "localhost.citrix.com" : "UA-2429794-27",
    "www.citrix.com" : "UA-2429794-25",
    "stg-www.citrix.com" : "UA-2429794-27"
}